// extracted by mini-css-extract-plugin
module.exports = {"button":"icon-button_button__wNKVc","iconContainer":"icon-button_iconContainer__sQzDn"};